/// <reference path="../../../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Dashboards {

    @Serenity.Decorators.registerEditor()
    export class ChartSeriesEditor extends Common.GridEditorBase<ChartSeries> {
        protected getColumnsKey() { return ChartSeriesColumns.columnsKey; };
        protected getDialogType() { return ChartSeriesDialog; }

        protected getAddButtonCaption() {
            return "Add Series";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            buttons.push({
                title: 'Update Series',
                cssClass: 'update-series-button',
                icon: 'fa-refresh',
                onClick: () => this.updateSeries && this.updateSeries()
            });

            return buttons;
        }

        protected getPersistanceStorage() {
            return null;
        }

        public updateSeries: () => void;

        public setValue(value: ChartSeries[], merge: boolean = true) {
            if (!merge) {
                this.value = value || [];
                return;
            }

            var oldByField: Q.Dictionary<ChartSeries> = {};
            for (var k of (this?.value || []))
                oldByField[k.Field] = k;

            this.value = (value || []).map(x => {
                var old = oldByField[x.Field];
                if (old) {
                    old = Q.deepClone(old);
                    return old;
                }
                return x;
            });
        }

        validateEntity(row: ChartSeries, id) {
            row.Type = Q.toId(row.Type);
            return true;
        }

        initDialog(dlg) {
            super.initDialog(dlg);
            var field = dlg.form.Field.value;
            dlg.form.Field.items = this.fieldList;
            dlg.form.Field.value = null;
            dlg.form.Field.value = field;
        }

        fieldList: Serenity.Select2Item[];
    }
}